const HIGHLIGHT_COLOR = "var(--bs-primary-bg-subtle)";

export const highlight = (text, search, color = HIGHLIGHT_COLOR) => {
  if (!text) return "";
  if (!search) return text;

  const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <mark key={i} style={{ backgroundColor: color, color: "inherit", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    ),
  );
};
